import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './MyApplications.css';

const API = '/api/cms';
const SL = { new: 'Новая', in_progress: 'В работе', completed: 'Завершена', cancelled: 'Отменена' };
const PL = { low: 'Низкий', medium: 'Средний', high: 'Высокий', critical: 'Критический' };
const PR_COLORS = { low: '#22c55e', medium: '#3b82f6', high: '#f59e0b', critical: '#ef4444' };

const MyApplications = () => {
  const [apps, setApps] = useState([]);
  const [tags, setTags] = useState([]);
  const [subTab, setSubTab] = useState('all');
  const [search, setSearch] = useState('');
  const [msg, setMsg] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [editedApps, setEditedApps] = useState({});
  const [commentText, setCommentText] = useState({});
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [tab, setTab] = useState('applications');
  const [filterPriority, setFilterPriority] = useState('');
  const [filterOverdue, setFilterOverdue] = useState(false);

  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const h = { Authorization: `Bearer ${token}` };
  const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';

  useEffect(() => { loadData(); }, [subTab, tab]);

  const loadData = async () => {
    try {
      if (tab === 'applications') {
        const params = new URLSearchParams();
        params.append('limit', '200');
        params.append('assigned', subTab === 'assigned' ? 'true' : 'false');
        if (search) params.append('search', search);
        if (filterPriority) params.append('priority', filterPriority);
        if (filterOverdue) params.append('overdue', 'true');

        const [a, s, t] = await Promise.all([
          axios.get(`${API}/applications?${params}`, { headers: h }),
          axios.get(`${API}/applications/stats`, { headers: h }),
          axios.get(`${API}/tags`, { headers: h })
        ]);
        setApps(a.data.applications || []);
        setStats(s.data);
        setTags(t.data);
        const u = await axios.get(`${API}/users`, { headers: h });
        setUsers(u.data);
      } else if (tab === 'analytics') {
        const a = await axios.get(`${API}/analytics?period=7d`, { headers: h });
        setAnalytics(a.data);
      }
    } catch (e) { setMsg('Ошибка: ' + (e.response?.data?.message || e.message)); }
  };

  const startEdit = (id, field, value) => {
    setEditedApps(prev => ({ ...prev, [id]: { ...(prev[id] || {}), [field]: value } }));
  };

  const applyChanges = async (id) => {
    const edit = editedApps[id];
    if (!edit) return;
    const app = apps.find(a => a._id === id);
    const statusChanged = edit.status && edit.status !== app.status;
    const assigneeChanged = edit.assignedTo !== undefined && edit.assignedTo !== (app.assignedTo?._id || '');
    const hasComment = edit.comment?.trim();
    if ((statusChanged || assigneeChanged) && !hasComment) {
      setMsg('⚠️ При смене статуса или ответственного обязателен комментарий');
      return;
    }
    try {
      await axios.put(`${API}/applications/${id}`, {
        status: edit.status || app.status,
        assignedTo: edit.assignedTo !== undefined ? edit.assignedTo : (app.assignedTo?._id || null),
        priority: edit.priority || app.priority,
        comment: edit.comment || '',
        tags: edit.tags !== undefined ? edit.tags : undefined,
        dueDate: edit.dueDate !== undefined ? edit.dueDate : undefined
      }, { headers: h });
      setEditedApps(prev => { const n = { ...prev }; delete n[id]; return n; });
      setCommentText(prev => ({ ...prev, [id]: '' }));
      loadData(); setMsg('✅ Заявка обновлена');
    } catch (e) { setMsg(e.response?.data?.message || 'Ошибка'); }
  };

  const cancelEdit = (id) => {
    setEditedApps(prev => { const n = { ...prev }; delete n[id]; return n; });
    setCommentText(prev => ({ ...prev, [id]: '' }));
  };

  const filtered = apps.filter(a => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (a.name || '').toLowerCase().includes(q) || (a.phone || '').toLowerCase().includes(q) ||
      (a.email || '').toLowerCase().includes(q) || (a.message || '').toLowerCase().includes(q) ||
      (a.service || '').toLowerCase().includes(q) || (a.status || '').toLowerCase().includes(q);
  });

  return (
    <div className="my-apps">
      <div className="my-apps-header">
        <div>
          <h1>📋 Управление заявками</h1>
          <p className="subtitle">
            {isAdmin ? 'Все заявки в системе' : 'Заявки, назначенные на вас'}
          </p>
        </div>
        <div className="my-apps-header-actions">
          <Link to="/dashboard" className="btn btn-outline">🏠 Личный кабинет</Link>
          <a href="/" className="btn btn-outline">🌐 На сайт</a>
        </div>
      </div>

      {msg && <div className="alert">{msg}<button onClick={() => setMsg('')}>✕</button></div>}

      <div className="my-apps-content">
        {tab === 'applications' && (
          <div className="applications-tab">
            <div className="sub-tabs">
              <button className={`sub-tab ${subTab === 'all' ? 'active' : ''}`} onClick={() => setSubTab('all')}>📋 Все заявки ({stats?.total || 0})</button>
              <button className={`sub-tab ${subTab === 'assigned' ? 'active' : ''}`} onClick={() => setSubTab('assigned')}>👤 Назначенные на меня</button>
            </div>

            {stats && (
              <div className="stats-grid">
                <div className="stat-card"><span className="stat-value">{stats.total}</span><span className="stat-label">Всего</span></div>
                <div className="stat-card new"><span className="stat-value">{stats.new}</span><span className="stat-label">Новых</span></div>
                <div className="stat-card progress"><span className="stat-value">{stats.inProgress}</span><span className="stat-label">В работе</span></div>
                <div className="stat-card done"><span className="stat-value">{stats.completed}</span><span className="stat-label">Завершено</span></div>
                <div className="stat-card overdue"><span className="stat-value">{stats.overdue || 0}</span><span className="stat-label">Просрочено</span></div>
              </div>
            )}

            <div className="apps-controls">
              <input type="text" className="search-input" placeholder="🔍 Поиск..." value={search} onChange={e => setSearch(e.target.value)} />
              <select value={filterPriority} onChange={e => setFilterPriority(e.target.value)} className="filter-select">
                <option value="">Все приоритеты</option>
                <option value="low">Низкий</option>
                <option value="medium">Средний</option>
                <option value="high">Высокий</option>
                <option value="critical">Критический</option>
              </select>
              <label className="filter-checkbox"><input type="checkbox" checked={filterOverdue} onChange={e => setFilterOverdue(e.target.checked)} /> Просроченные</label>
            </div>

            <div className="apps-grid">
              {filtered.map(app => {
                const edit = editedApps[app._id] || {};
                const hasChanges = Object.keys(edit).length > 0;
                const currentStatus = edit.status || app.status;
                const currentPriority = edit.priority || app.priority;
                const currentAssignee = edit.assignedTo !== undefined ? edit.assignedTo : (app.assignedTo?._id || '');
                const canEdit = true;
                const isOverdue = app.isOverdue && app.status !== 'completed' && app.status !== 'cancelled';
                const dueDate = app.dueDate ? new Date(app.dueDate) : null;
                const isUrgent = app.isUrgent;

                return (
                  <div key={app._id} className={`app-card-admin ${expandedId === app._id ? 'expanded' : ''} ${hasChanges ? 'editing' : ''} ${isOverdue ? 'overdue' : ''}`}>
                    <div className="app-card-header" onClick={() => setExpandedId(expandedId === app._id ? null : app._id)}>
                      <div className="app-card-header-left">
                        <span className={`status-badge status-${currentStatus}`}>{SL[currentStatus] || currentStatus}</span>
                        <span className="priority-badge" style={{ background: PR_COLORS[currentPriority] || '#3b82f6' }}>
                          {PL[currentPriority] || currentPriority}
                        </span>
                        {isOverdue && <span className="overdue-badge">⚠️ Просрочено</span>}
                        {isUrgent && !isOverdue && <span className="urgent-badge">🔥 Срочно</span>}
                      </div>
                      <span className="app-date">{new Date(app.createdAt).toLocaleString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                    </div>
                    <div className="app-card-body">
                      <div className="app-card-top-row">
                        <h3>{app.name}</h3>
                      </div>
                      <p className="app-contact">📞 <a href={`tel:${app.phone}`}>{app.phone}</a> | ✉️ <a href={`mailto:${app.email}`}>{app.email}</a></p>
                      <p className="app-service">🔧 {app.service || 'Не указана'}</p>

                      {dueDate && (
                        <p className={`app-due-date ${isOverdue ? 'overdue-text' : ''}`}>
                          📅 Дедлайн: {dueDate.toLocaleString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                          {app.slaPercentage !== null && <span className="sla-bar"><span className="sla-fill" style={{ width: `${Math.min(100, app.slaPercentage)}%`, background: app.slaPercentage > 80 ? '#ef4444' : app.slaPercentage > 50 ? '#f59e0b' : '#22c55e' }}></span></span>}
                        </p>
                      )}

                      {app.tags && app.tags.length > 0 && (
                        <div className="app-tags">
                          {app.tags.map((tag, i) => {
                            const tagData = tags.find(t => t.name === tag);
                            return <span key={i} className="tag-badge" style={{ background: tagData?.color || '#e2e8f0', color: tagData?.color ? '#fff' : '#475569' }}>{tagData?.displayName || tag}</span>;
                          })}
                        </div>
                      )}

                      <div className="app-assign">
                        <label>👨‍💼 Ответственный:</label>
                        {canEdit ? (
                          <select value={currentAssignee} onChange={e => startEdit(app._id, 'assignedTo', e.target.value)}>
                            {users.map(u => (
                              <option key={u._id} value={u._id}>{u.name} ({u.email}) {u.workStatus === 'dayoff' ? '🔴' : '🟢'}</option>
                            ))}
                          </select>
                        ) : (
                          <span>{app.assignedTo?.name || 'Не назначен'}</span>
                        )}
                      </div>

                      <div className="app-priority-edit">
                        <label>⚡ Приоритет:</label>
                        <select value={currentPriority} onChange={e => startEdit(app._id, 'priority', e.target.value)}>
                          <option value="low">Низкий</option>
                          <option value="medium">Средний</option>
                          <option value="high">Высокий</option>
                          <option value="critical">Критический</option>
                        </select>
                      </div>

                      <div className="app-tags-edit">
                        <label>🏷️ Теги:</label>
                        <input type="text" placeholder="через запятую" value={edit.tags !== undefined ? edit.tags.join(', ') : (app.tags || []).join(', ')} onChange={e => startEdit(app._id, 'tags', e.target.value.split(',').map(t => t.trim().toLowerCase()).filter(Boolean))} />
                      </div>

                      <div className="app-due-edit">
                        <label>📅 Дедлайн:</label>
                        <input type="datetime-local" value={edit.dueDate || (app.dueDate ? new Date(app.dueDate).toISOString().slice(0, 16) : '')} onChange={e => startEdit(app._id, 'dueDate', e.target.value)} />
                      </div>

                      {app.message && <div className={`app-message ${expandedId === app._id ? 'expanded' : 'collapsed'}`}>💬 {app.message}</div>}
                      {expandedId === app._id && app.message?.length > 100 && <button className="expand-btn" onClick={() => setExpandedId(null)}>Свернуть</button>}

                      {app.comments && app.comments.length > 0 && (
                        <div className="app-comments">
                          <h4>📝 История изменений</h4>
                          {app.comments.map((c, i) => (
                            <div key={i} className="comment-item">
                              <div className="comment-header">
                                <span className="comment-user">{c.userName || 'Система'}</span>
                                <span className="comment-date">{new Date(c.createdAt).toLocaleString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                              </div>
                              {c.fromStatus && c.toStatus && (
                                <div className="comment-status-change">
                                  <span className={`status-badge status-${c.fromStatus}`}>{SL[c.fromStatus]}</span>
                                  <span className="arrow">→</span>
                                  <span className={`status-badge status-${c.toStatus}`}>{SL[c.toStatus]}</span>
                                </div>
                              )}
                              {c.assigneeChanged && (
                                <div className="comment-assignee-change">
                                  👨‍💼 {c.assigneeChanged.from === 'не назначен' ? 'Не назначен' : users.find(u => String(u._id) === c.assigneeChanged.from)?.name || c.assigneeChanged.from} → {users.find(u => String(u._id) === c.assigneeChanged.to)?.name || c.assigneeChanged.to}
                                </div>
                              )}
                              <p className="comment-text">{c.text}</p>
                            </div>
                          ))}
                        </div>
                      )}

                      {canEdit && (
                        <div className="app-status-change">
                          <div className="status-row">
                            <select value={currentStatus} onChange={e => startEdit(app._id, 'status', e.target.value)}>
                              <option value="new">Новая</option>
                              <option value="in_progress">В работе</option>
                              <option value="completed">Завершена</option>
                              <option value="cancelled">Отменена</option>
                            </select>
                          </div>
                          <div className="comment-row">
                            <input type="text" className="comment-input" placeholder="💬 Комментарий (обязателен при смене статуса/ответственного)" value={edit.comment || commentText[app._id] || ''} onChange={e => startEdit(app._id, 'comment', e.target.value)} />
                          </div>
                          {hasChanges && (
                            <div className="edit-actions">
                              <button className="btn btn-primary btn-apply" onClick={() => applyChanges(app._id)}>✅ Применить</button>
                              <button className="btn btn-outline-dark btn-cancel" onClick={() => cancelEdit(app._id)}>✕ Отмена</button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {tab === 'analytics' && analytics && (
          <div className="analytics-page">
            <h2>📈 Аналитика</h2>
            <div className="stats-grid">
              <div className="stat-card"><span className="stat-value">{analytics.totalVisits}</span><span className="stat-label">Визитов</span></div>
              <div className="stat-card"><span className="stat-value">{analytics.uniqueVisits}</span><span className="stat-label">Уникальных</span></div>
              <div className="stat-card"><span className="stat-value">{analytics.currentVisitors}</span><span className="stat-label">Онлайн</span></div>
            </div>
            <h3>По дням</h3>
            <div className="daily-chart">{analytics.dailyVisits?.map(d => (<div key={d.date} className="day-bar"><div className="bar" style={{ height: `${Math.max(10, (d.visits / Math.max(...analytics.dailyVisits.map(x => x.visits))) * 100)}%` }}></div><span className="date">{d.date.slice(5)}</span><span className="count">{d.visits}</span></div>))}</div>
          </div>
        )}
      </div>

      <div className="my-apps-tabs">
        <button className={`tab ${tab === 'applications' ? 'active' : ''}`} onClick={() => setTab('applications')}>📋 Заявки</button>
        {isAdmin && <button className={`tab ${tab === 'analytics' ? 'active' : ''}`} onClick={() => setTab('analytics')}>📈 Аналитика</button>}
      </div>
    </div>
  );
};

export default MyApplications;
